import { utils as reducerUtils, store } from 'redux-rest-reducer';
import { ACTIONS } from 'actions/curriculum-home';
import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.INVALIDATE_ITEM:
      return reducerUtils.changeItemToStale(state, payload.id, payload.query);
    default:
      return state;
  }
});

export function getCurriculumMap(curriculumHomeDetails, studentId) {
  const { data: curriculumData } = store.get(curriculumHomeDetails, studentId) || {};
  const { curriculum_map: curriculumMap } = curriculumData || {};

  return curriculumMap;
}

export function getDisciplineMap(curriculumHomeDetails, studentId) {
  const { data: curriculumData } = store.get(curriculumHomeDetails, studentId) || {};
  const { discipline_map: disciplineMap } = curriculumData || {};

  return disciplineMap;
}

export function getEnrolledPrograms(curriculumHomeDetails, studentId) {
  const { data: curriculumData } = store.get(curriculumHomeDetails, studentId) || {};
  const { user_programs: enrolledPrograms } = curriculumData || {};

  return enrolledPrograms || [];
}

export function getRewardSummary(curriculumHomeDetails, studentId) {
  const { data: curriculumData } = store.get(curriculumHomeDetails, studentId) || {};
  const { rewards_summary: rewardSummary } = curriculumData || {};

  return rewardSummary;
}
